import { downloadSetupFile } from 'modules/api/setup';
import Button, { Color, Size } from 'lib/Button';
import downloadSvg from 'assets/icons/download.svg';
import { download } from 'utils/download';
import { cancelFunctions } from 'utils/cancelFunctions';
import { SetupFrameInformation } from 'components/pages/InventoryManagement/Setup/Setup.types';

const DownloadRenderer = ({ data }: { data: SetupFrameInformation }): React.ReactElement => {
  const handleDownloadFile = async (): Promise<void> => {
    try {
      const response = await downloadSetupFile(cancelFunctions, data.fileId);

      download(new Blob([response.data]), data.fileName);
    } catch {} // eslint-disable-line no-empty
  };

  return (
    <div className="table-action-button">
      <Button
        color={Color.TERTIARY}
        onClick={handleDownloadFile}
        size={Size.LARGE}
        svg={downloadSvg}
        label="Download"
      />
    </div>
  );
};

export default DownloadRenderer;
